/**
 * Plugin operates the main info modal added to the APP root element.
 * Modal can be shown in different colors depending on the type provided.
 *
 * Usage:
 *   - from component
 *      this.$numberInfoModal.show(params);
 *   - from actions or other resources that do not have an access to the vue object
 *      - pass in the 'this.$numberInfoModal' as parameter
 *      - then call 'show' on that parameter
 *
 * @param title Optional. Title for the modal. If omitted then the type is used as title.
 * IMPORTANT - Not yet implemented
 * @param {string} [titleIcon] - Icon for the title. Possible options are 'info', 'error', 'warning.
 * @param message Message for the modal content box.
 * @param type Optional. Type of the modal. Possible options are 'ERROR', 'INFO'. Default 'INFO'.
 * @param confirmButtonText Optional. Text for the callback button. Default 'Confirm'.
 * @param confirmCallback Optional. Method to be executed from the modal.
 */

import NumberInfoModalComponent from './NumberInfoModal.component';

const NumberInfoModal = {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Vue.component('NumberInfoModal', NumberInfoModalComponent);
    Vue.prototype.$numberInfoModalEventBus = new Vue();
    Vue.prototype.$numberInfoModal = {
      show(params) {
        Vue.prototype.$numberInfoModalEventBus.$emit('show', params);
      },
    };
  },
};

export default NumberInfoModal;
